import { render } from "./ModalContentForm.vue?vue&type=template&id=02330c0e&lang=true"
import script from "./ModalContentForm.vue?vue&type=script&lang=js"
export * from "./ModalContentForm.vue?vue&type=script&lang=js"
script.render = render

export default script